"use client";

import { useQuery } from "@tanstack/react-query";
import { publicSettingsQuery } from "src/utils/art-catalogue-enabled";

/** False while loading or on failure: the party pages stay closed rather than guess open. */
export function usePartyCameraEnabled(): { enabled: boolean; isLoading: boolean } {
  const { data, isLoading } = useQuery(publicSettingsQuery);
  return { enabled: data?.partyCameraEnabled === true, isLoading };
}
